"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformSpinData = exports.getCartContinueUrl = void 0;
var _utils = require("@site/utils");
const transformSpinData = ({
  findResponse = {
    Products: [],
    RecommendedDomains: [],
    IsVatCountry: false
  },
  showFreeIndicator,
  maxSpins = 40,
  cart,
  isCountdownTimerEnabled = false
}) => {
  return findResponse?.RecommendedDomains?.length > 0 ? findResponse.RecommendedDomains?.map(domain => {
    const product = findResponse.Products?.find(productField => domain.ProductId === productField.ProductId && domain.TierId === productField.TierId) || {};
    domain = {
      ...domain,
      isInCart: Array.from(cart?.contents || []).some(({
        Fqdn
      }) => Fqdn === domain.Fqdn),
      product,
      priceInfo: product.PriceInfo,
      hasPromo: product.PriceInfo?.IsPromoDiscount && product.PriceInfo?.PromoRegLengthFlag === 2,
      isPremium: (0, _utils.isAftermarketPremium)(domain),
      isRegPremium: (0, _utils.isRegPremium)(domain),
      isAuction: (0, _utils.isAuction)(domain),
      hasIcannFee: !findResponse.IsVatCountry && product.hasIcannFee,
      IcannFeePrice: findResponse.IcannFeePrice,
      IsVatCountry: findResponse.IsVatCountry,
      key: domain.Fqdn,
      premiumPriceDisplay: domain.isPremium || domain.isAuction ? domain.PriceDisplay : null,
      content: product.Content || null,
      isFree: domain.PhaseId === product.PhaseId && !domain.isPremium && !domain.isRegPremium && !domain.isAuction && showFreeIndicator,
      isCountdownTimerEnabled
    };
    return domain;
  }).slice(0, maxSpins) : [];
};
exports.transformSpinData = transformSpinData;
const getCartContinueUrl = (host, skipConfig) => {
  const marketCookie = (0, _utils.getMarket)();
  const {
    languagePath
  } = _utils.Markets[marketCookie] || {};
  const path = languagePath ? `/${languagePath}/dpx/registration` : '/dpx/registration';
  const params = skipConfig ? '?tmskey=dpp_skip_config' : '';
  return `${host}${path}${params}`;
};
exports.getCartContinueUrl = getCartContinueUrl;